import { useState } from 'react';
import { PaymentMethod } from '@/models';
import { TariffsPaymentMethodSelector } from '../TariffsPaymentMethodSelector';
import { CardCheckoutForm } from './Card';
import CryptoCheckoutForm from './Crypto/CryptoCheckoutForm';

type TariffsPaymentMethodProps = {
  tariffCost: number;
  planId: number;
  tariffType?: string;
};

const TariffsPaymentMethod = ({
  tariffCost,
  planId,
  tariffType,
}: TariffsPaymentMethodProps) => {
  const [currentPaymentMethod, setCurrentPaymentMethod] =
    useState<PaymentMethod>();
  const onPaymentMethodChange = (paymentMethod: PaymentMethod) => {
    setCurrentPaymentMethod(paymentMethod);
  };

  return (
    <div>
      <TariffsPaymentMethodSelector
        onPaymentMethodChange={onPaymentMethodChange}
        tariffCost={tariffCost}
      />
      {currentPaymentMethod?.isCrypto ? (
        <CryptoCheckoutForm
          currency={currentPaymentMethod.symbol}
          planId={planId}
          tariffType={tariffType}
        />
      ) : (
        <CardCheckoutForm planId={planId} tariffType={tariffType} />
      )}
    </div>
  );
};

export default TariffsPaymentMethod;
